import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type LanguageConfigFragment = { languageTagId?: string | null, languageTag?: { options: Array<{ name: string, id: string }> } | null };


export type LanguageConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LanguageConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment LanguageConfig on LanguageConfigType {
  languageTagId
  languageTag {
    options {
      name
      id
    }
  }
}
    `;